import { render } from "./HelloWorld.vue?vue&type=template&id=7fbfaaea&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=7fbfaaea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7fbfaaea"

export default script